<div class="row" style="margin-left: 0px;margin-right: 0px;">


    <div class="col-md-12">
      <h4 class="title">Payment History</h4>

      <div class="card-box">
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-4">
            <h5 class="form-lable">Due Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">FC/EXR:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Inst Amt FC/Base:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Principal Amount FC/Base:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Total Amount FC/Base:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Paid Amount FC/Base:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Pay Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <!-- <div class="col-md-12 mt-20">
                <button type="button" class="btn btn-primary">Add</button>
           </div> -->
      
        </div>
      </div>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
    </div>
    <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
    
        <ng-template pTemplate="header">
          <tr style="text-align: center;">
            <th>Due Date</th>
            <th>FC/EXR</th>
            <th>Inst Amt FC/Base</th>
            <th>Principal Amount FC/Base</th>
            <th>Total Amount FC/Base</th>
            <th>Paid Amount FC/Base</th>
            <th>Pay Date</th>
          </tr>
          <tr style="text-align: center;">
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
          </tr>
        </ng-template>
       </p-table>  </div>
    </div>
    <br>
    </div>